import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Resizer from "react-image-file-resizer";
import { fill_action } from "../../../actions/common_action/fillList_action";
import Loader from "../../../utils/Loader";
import {
  BASE_URL,
  countryActionId,
  responseError,
  toastError,
  toastSuccess,
} from "../../../utils/constants";
import Header from "../../../common_components/Header";
import {
  jury_profile_insertUpdate_action,
  jury_profile_detail_action,
} from "../../../actions/adminModule_action/juryProfile_action";
import Footer from "../../../common_components/Footer";
import MobileHeader from "../../../common_components/mobileHeader";

class JuryProfileAU extends Component {
  constructor(props) {
    super(props);
    this.state = {
      //rest
      isLoading: false,
      jury_id: "",
      Name: "",
      designation: "",
      companyName: "",
      EmailAddress: "",
      Phone: "",
      address: "",
      city: "",
      State: "",
      country_id: "",
      countryFillList: "",
      specialization: "",
      EducationLevel: "",
      BackgroundExperience: "",
      LanguageProficiency: "",
      user_id: "",

      about_me: "",
      FilePath: null,
      formFileType: "",
      formFile: "",

      // input validate
      NameErr: "",
      designationErr: "",
      companyNameErr: "",
      EmailAddressErr: "",
      PhoneErr: "",
      addressErr: "",
      about_meErr: "",
      FilePathErr: "",
      cityErr: "",
      stateErr: "",
      countryErr: "",
      specializationErr: "",
      is_active: true, downloadUrl: '',
      is_website_show: false,

      countryList: [],
      ProfileFileName: '',
      ProfileFilePath: '',
      ProfileFileType: '',
      profile_filepath: '',
    };
    this.juryProfileDetails = this.juryProfileDetails.bind(this);
    this.navigateBackJuryList = this.navigateBackJuryList.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("AwardsUserLoginData")) == null) {
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }

    setTimeout(() => {
      {
        sessionStorage.getItem("role_id") == 2 ? (
          this.props.navigate("/login")
        ) : <></>
      }
    }, 10);
    this.setState({
      user_id:
        sessionStorage.getItem("role_id") == 2
          ? sessionStorage.getItem("user_id") == "" ||
            sessionStorage.getItem("user_id") == null
            ? ""
            : sessionStorage.getItem("user_id")
          : null,
      is_active: this.props.location.state?.is_active
        ? this.props.location.state?.is_active
        : "",

    });
    const sortUrl = BASE_URL.split("/api");
    this.setState({ downloadUrl: sortUrl[0] });
    const { user_id } = this.state;

    const jury_id = this.props.location.state?.jury_id || "";

    if (jury_id) {
      this.setState({ jury_id }, () => {
        this.juryProfileDetails();
      });
    }
    this.getFillList(countryActionId, user_id, "", "");
  }

  getFillList(value, user_id, keyword, keyvalue) {
    // this.setState({ isLoading: true })
    this.props
      .fill_action(
        value,
        user_id == "" || user_id == null ? null : user_id,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        if (data.error != 1) {
          if (value == countryActionId) {
            this.setState({
              countryList: data.data,
              tempcountryList: data.data,
            });
          }
        } else {
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  inputValidate() {
    const {
      Name,
      address,
      Phone,
      EmailAddress,
      designation,
      specialization,
      country_id,
      city,
      companyName,
      State,
    } = this.state;

    let isValid = true;

    // Clear all errors initially
    this.setState({
      NameErr: "",
      addressErr: "",
      PhoneErr: "",
      EmailAddressErr: "",
      designationErr: "",
      specializationErr: "",
      companyNameErr: "",
      cityErr: "",
      stateErr: "",
      countryErr: "",
    });

    // Name validation
    if (!Name) {
      this.setState({ NameErr: "Please enter first name" });
      isValid = false;
    }

    // Address validation
    if (!address) {
      this.setState({ addressErr: "Please enter address line 1" });
      isValid = false;
    }

    // Phone validation
    if (!Phone) {
      this.setState({ PhoneErr: "Please enter mobile number" });
      isValid = false;
    } else {
      const cleanedPhone = Phone.replace(/\D/g, ""); // Remove non-digit characters
      const phoneRegex = /^\d{10}$/; // Phone should have 10 digits
      const validPhone = phoneRegex.test(cleanedPhone);
      if (!validPhone) {
        this.setState({
          PhoneErr: "Please enter a valid 10-digit phone number",
        });
        isValid = false;
      }
    }

    // Email validation
    if (!EmailAddress) {
      this.setState({ EmailAddressErr: "Please enter email id" });
      isValid = false;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex
      const validMail = emailRegex.test(EmailAddress);
      if (!validMail) {
        this.setState({
          EmailAddressErr: "Please enter a valid email address",
        });
        isValid = false;
      }
    }

    // Designation validation
    if (!designation) {
      this.setState({ designationErr: "Please enter designation" });
      isValid = false;
    }

    // Specialization validation
    if (!specialization) {
      this.setState({ specializationErr: "Please enter specialization" });
      isValid = false;
    }

    // Company Name validation
    if (!companyName) {
      this.setState({ companyNameErr: "Please enter Company Name" });
      isValid = false;
    }

    // City validation
    if (!city) {
      this.setState({ cityErr: "Please enter city" });
      isValid = false;
    }

    // State validation
    if (!State) {
      this.setState({ stateErr: "Please enter state" });
      isValid = false;
    }

    // Country validation
    if (!country_id || country_id === "Select" || country_id === "Country") {
      this.setState({ countryErr: "Please select a country" });
      isValid = false;
    }

    return isValid;
  }

  Email(e) {
    const email = e.target.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(email);
    this.setState({
      EmailAddress: email,
      EmailAddressErr: isValid ? "" : "Invalid email address",
    });
  }

InputFormat(e, type) {
    const inputValue = e.target.value;

    // Explicitly block numbers instead of failing on empty strings
    if (/\d/.test(inputValue)) {
      toast.error("Numbers not allowed", {
        position: "top-center",
        theme: "colored",
        autoClose: 1000,
      });
      return; 
    }

    // Safely allow empty strings, otherwise title-case the words
    const finalValue = inputValue
      ? inputValue
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")
      : "";

    if (type == "name") {
      this.setState({ Name: finalValue, NameErr: "" });
    } else if (type == "designation") {
      this.setState({ designation: finalValue, designationErr: "" });
    } else if (type == "company") {
      this.setState({ companyName: finalValue, companyNameErr: "" });
    } else if (type == "specialization") {
      this.setState({ specialization: finalValue, specializationErr: "" });
    } else if (type == "city") {
      this.setState({ city: finalValue, cityErr: "" });
    } else if (type == "state") {
      this.setState({ State: finalValue, stateErr: "" });
    } else if (type == "address") {
      this.setState({ address: finalValue, addressErr: "" });
    }
  }

  Phone(e) {
    const phoneInput = e.target.value;
    const cleanedPhone = phoneInput.replace(/\D/g, "");
    const phoneRegex = /^\d{10}$/;
    const isValid = phoneRegex.test(cleanedPhone);
    this.setState({
      Phone: cleanedPhone,
      PhoneErr: isValid ? "" : "Invalid phone number. Must be 10 digits.",
    });
  }

  navigateBackJuryList() {
    this.props.navigate("/juryProfile");
  }
  clearFields() {
    this.setState({
      jury_id: "",
      Name: "",
      Dob: "",
      address: "",
      Phone: "",
      Telephone: "",
      EmailAddress: "",
      designation: "",
      specialization: "",
      EducationLevel: "",
      Ethnicity: "",
    });
  }

  juryProfileDetails() {
    var jury_id = this.props.location.state.jury_id;
    this.setState({ isLoading: true });
    this.props
      .jury_profile_detail_action(jury_id)
      .then((data) => {
        if (data.error != 1) {
          this.setState({ isLoading: false });
          this.setState({
            jury_id: data.data[0]["jury_id"],
            Name: data.data[0]["name"],
            designation: data.data[0]["designation"],
            companyName: data.data[0]["company_name"],
            EmailAddress: data.data[0]["email_address"],
            Phone: data.data[0]["mobile_number"],
            address: data.data[0]["address"],
            city: data.data[0]["city"],
            State: data.data[0]["state"],
            country_id: data.data[0]["country_id"],
            specialization: data.data[0]["specialization"],
            EducationLevel: data.data[0]["education_level"],
            BackgroundExperience: data.data[0]["background_experience"],
            LanguageProficiency: data.data[0]["language_proficiency"],
            about_me: data.data[0]["about_me"],
            FilePath: data.data[0]["profile_image"],
            user_id: data.data[0]["user_id"],
            is_active: data.data[0]["is_active"],
            is_website_show: data.data[0]["is_website_show"],
            profile_filepath: data.data[0]["profile_filepath"],

          });

          if (data.data[0]["profile_filepath"] != null && data.data[0]["profile_filepath"] != '') {
            const file = data.data[0]["profile_filepath"].split(`${data.data[0]['jury_id']}/`)
            const displayFile = data.data[0]["profile_filepath"].split('.')
            this.setState({
              ProfileFileName: file[1],
              download_profile_filepath: displayFile[1] + '.' + displayFile[2],
            })
          }
        } else {
          responseError(data);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  handleInputChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }
 handleSubmit(event) {
    event.preventDefault();
    const { 
      user_id, Name, designation, companyName, EmailAddress, Phone,
      address, city, State, country_id, specialization, EducationLevel,
      BackgroundExperience, LanguageProficiency, about_me, jury_id,
      FilePath, formFileType, formFile, ProfileFilePath, ProfileFileType,
      ProfileFileName, profile_filepath, is_website_show, is_active 
    } = this.state;
    
    const isValid = this.inputValidate();
    
    if (!isValid) {
      toastError("Please enter all mandatory fields");
      return;
    } else {
      this.setState({ isLoading: true });
      const confirmed = window.confirm('Are you sure to submit this jury profile?');
      
      if (confirmed) {
        // FORCE is_active to 1 if there is no jury_id (insert case)
        const finalIsActive = jury_id ? is_active : 1;

        this.props
          .jury_profile_insertUpdate_action(
            user_id, jury_id, Name, designation, companyName, EmailAddress, Phone,
            address, city, State, country_id, specialization, EducationLevel, 
            BackgroundExperience, LanguageProficiency, about_me, FilePath, 
            formFileType, formFile, ProfileFilePath, ProfileFileType, 
            ProfileFileName, profile_filepath, is_website_show, finalIsActive
          ).then((data) => {
            if (data.error !== 1) {
              this.setState({ isLoading: false }, () => {
                toastSuccess(
                  jury_id
                    ? "Jury Profile Updated Successfully"
                    : "Jury Profile Submitted Successfully"
                );
                setTimeout(() => {
                  this.navigateBackJuryList();
                }, 1000);
              });
            } else if (data.error == 1) {
              toastError(data.msg)
              this.setState({ isLoading: false })
            } else {
              responseError(data);
            }
          })
          .catch((e) => {
            console.log(e);
            this.setState({ isLoading: false });
          });
      } else {
        this.setState({ isLoading: false })
      }
    }
  }

  // Method to handle image upload and preview
  handleImageUpload = async (e) => {

    e.preventDefault();
    const file = e.target.files[0];
    const finalImageArray = [];

    if (file) {

      if (file.size > 2097152) {
        // Check if the file size is more than 2MB
        toast.error("File size more than 2MB is not allowed.", {
          position: "top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
        return;
      }

      if (
        file.name.toLowerCase().includes(".jpeg") ||
        file.name.toLowerCase().includes(".png") ||
        file.name.toLowerCase().includes(".jpg")
      ) {
        const image = await this.resizeFile(file);
        const fileExtension = file.name.split(".").pop();

        this.setState({
          FilePath: image,
          formFileType: fileExtension,
          formFile: image,
        })

      } else {
        toast.error("Only .jpeg, .png, .jpg files are allowed", {
          position: "top-center",
          theme: "colored",
          autoClose: 3000,
          hideProgressBar: true,
        });
      }
    }
  };

  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        500,
        600,
        "JPEG",
        80,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        300,
        300
      );
    });

  triggerFileInput = () => {
    this.fileInputRef.click();
  };

  clearFileInput = () => {
    this.setState({
      FilePath: null,
      formFileType: "",
      formFile: "",
    })
  };

  onPdfSelect = (file) =>
    new Promise((resolve) => {
      let base64;
      // FileReader function for read the file.
      let fileReader = new FileReader();
      // Onload of file read the file content
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result;
        // Print data in console
        resolve(base64);
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
    });

  onProfileFormFilePick = async (e, file) => {
    e.preventDefault()
    const { formFile, trcFile, ProfileFile, formFileType, ProfileFileType, trcFileType } = this.state
    var image = '';
    if (file[0]['size'] > 5242880) {
      toast.error('File size more than 5MB are not allow.', {
        position: "top-center",
        theme: 'colored',
        autoClose: 3000,
        hideProgressBar: true,
      })

    } else {
      if (file[0]['name'].toString().toLowerCase().includes('.pdf')
      ) {
        if (file[0]['name'].includes('pdf')) {
          image = await this.onPdfSelect(file[0]);
        }

        this.setState({ ProfileFilePath: image, ProfileFileName: file[0]['name'] })
        const fileType = file[0]['type']
        var fileTypeList;
        if (fileType.includes("/")) {
          fileTypeList = fileType.split("/")

        }
        this.setState({ ProfileFileType: fileTypeList.length > 0 ? fileTypeList[1] : '' })
      } else {
        toast.error('Only .pdf files are allowed', {
          position: "top-center",
          theme: 'colored',
          autoClose: 3000,
          hideProgressBar: true,
        })
      }
    }
  }

  removeProfileFormFile() {
    this.setState({
      ProfileFileName: '',
      ProfileFilePath: '',
      ProfileFileType: '',
      profile_filepath: '',
    })
  }

  handleViewFile = (base64String, fileName) => {
    // Extract MIME type and Base64 data
    const mimeType = base64String.split(';')[0].split(':')[1]; // Extract MIME type (e.g., 'image/png' or 'application/pdf')
    const byteCharacters = atob(base64String.split(',')[1]); // Extract Base64 content
    const byteNumbers = Array.from(byteCharacters).map(char => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    // Create a URL for the Blob
    const fileURL = URL.createObjectURL(blob);

    if (mimeType.startsWith('image/') || mimeType === 'application/pdf') {
      // Open viewable files directly
      const newTab = window.open(fileURL, '_blank', 'noopener,noreferrer');
      if (newTab) {
        newTab.document.title = fileName; // Set the tab title to the file name
      }
    } else {
      // Download non-viewable files
      const link = document.createElement('a');
      link.href = fileURL;
      link.download = fileName; // Use the specific file name for the download
      link.click();
    }

    // Clean up the blob URL after the file action
    setTimeout(() => URL.revokeObjectURL(fileURL), 500);
  };


  render() {
    const {
      isLoading, jury_id, Name, designation, companyName, EmailAddress, Phone, address,
      city, State, country_id, specialization, EducationLevel, BackgroundExperience, LanguageProficiency,
      about_me, FilePath, formFileType, formFile, NameErr, designationErr, companyNameErr,
      cityErr, stateErr, countryErr, specializationErr, addressErr, about_meErr, PhoneErr,
      EmailAddressErr, EducationLevelErr, is_active, is_website_show, countryList, downloadUrl, ProfileFilePath, ProfileFileType, ProfileFileName, profile_filepath
    } = this.state;

    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">

            <div className="website-view">
              <Header data={[8]} />
            </div>
            <div className="mobile-view">
              <MobileHeader data={[8]} />
            </div>
            <section class='header_margin_top'>
              <div className="container-fluid">
                <div className="page-header">
                  <h2 class="mb-3 dashboard-tit  py-0 blog-name blog-name-1">
                    {jury_id ? "Edit Jury Profile" : "Add Jury Profile"}
                  </h2>
                  <div className="Service_display pt-2">
                    <h6 className="Services_Active_or_Not">
                      {is_website_show == 1
                        ? "Publish on Website"
                        : "Unpublish on Website"}
                    </h6>
                    <div className="checkbox checbox-switch">
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={is_website_show == 1}
                          onChange={() => {
                            this.setState((prevState) => ({
                              is_website_show: prevState.is_website_show === 1 ? 0 : 1,
                            }));
                          }}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div> &nbsp; &nbsp; &nbsp;
                    <h6 className="Services_Active_or_Not">
                      {jury_id
                        ? is_active == 1
                          ? "Active"
                          : "Inactive"
                        : "Active"}
                    </h6>
                    <div className="checkbox checbox-switch">
                      <label className="switch">
                        {jury_id ? (
                          <>
                            <input
                              type="checkbox"
                              checked={is_active === 1}
                              onChange={() => {
                                this.setState((prevState) => ({
                                  is_active: prevState.is_active === 1 ? 0 : 1,
                                }));
                              }}
                            />
                            <span className="slider round"></span>
                          </>
                        ) : (
                          <>
                            <input type="checkbox" checked={true} readOnly />
                            <span className="slider round"></span>
                          </>
                        )}
                      </label>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="company_info">
                    <fieldset>
                      <legend>Personal Information</legend>
                      <div className="outside_input_field ">
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>
                                Name <span class="mendatory_class">*</span>
                              </label>
                              <input
                                value={Name}
                                type="text"
                                class="form-control border-input border-input"
                                required
                                // onKeyDown={(e) => this.handleKeyDown(e)}
                                maxLength={250}
                                onChange={(e) =>
                                  this.InputFormat(e, "name")
                                }
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {NameErr}
                                </span>
                              }

                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>
                                Designation <span class="mendatory_class">*</span>
                              </label>
                              <input
                                value={designation}
                                type="text"
                                class="form-control border-input border-input"
                                // onKeyDown={(e) => this.handleKeyDown(e)}
                                maxLength={500}
                                onChange={(e) =>
                                  this.InputFormat(e, "designation")
                                }
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {designationErr}
                                </span>
                              }

                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label >
                                Company Name{" "}
                                <span class="mendatory_class">*</span>
                              </label>
                              <input
                                value={companyName}
                                type="text"
                                class="form-control border-input border-input"
                                required
                                // onKeyDown={(e) => this.handleKeyDown(e)}
                                maxLength={1000}
                                onChange={(e) =>
                                  this.InputFormat(e, "company")
                                }
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {companyNameErr}
                                </span>
                              }

                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>
                                Email Address{" "}
                                <span class="mendatory_class">*</span>
                              </label>
                              <input
                                value={EmailAddress}
                                type="text"
                                class="form-control border-input border-input"
                                required
                                // onKeyDown={(e) => this.handleKeyDown(e)}
                                onChange={(e) => this.Email(e)}
                                maxLength={200}
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {EmailAddressErr}
                                </span>
                              }

                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>
                                Phone No{" "}
                                <span class="mendatory_class">*</span>
                              </label>
                              <input
                                value={Phone}
                                type="text"
                                class="form-control border-input border-input"
                                required
                                // onKeyDown={(e) => this.handleKeyDown(e)}
                                onChange={(e) => this.Phone(e)}
                                maxLength={10}
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {PhoneErr}
                                </span>
                              }

                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>
                                Specialization{" "}
                                <span class="mendatory_class">*</span>
                              </label>
                              <input
                                value={specialization}
                                type="text"
                                class="form-control border-input border-input"
                                required
                                onChange={(e) =>
                                  this.InputFormat(e, "specialization")
                                }
                                maxLength={500}
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {specializationErr}
                                </span>
                              }
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>
                                City Name{" "}
                                <span class="mendatory_class">*</span>
                              </label>
                              <input
                                value={city}
                                type="text"
                                class="form-control border-input border-input"
                                required
                                // onKeyDown={(e) => this.handleKeyDown(e)}
                                onChange={(e) =>
                                  this.InputFormat(e, "city")
                                }
                                maxLength={250}
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {cityErr}
                                </span>
                              }

                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>
                                State Name{" "}
                                <span class="mendatory_class">*</span>
                              </label>
                              <input
                                value={State}
                                type="text"
                                class="form-control border-input border-input"
                                required
                                onChange={(e) =>
                                  this.InputFormat(e, "state")
                                }
                                maxLength={250}
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {stateErr}
                                </span>
                              }
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>
                                Country Name{" "}
                                <span class="mendatory_class">*</span>
                              </label>
                              <select
                                className="form-control"
                                name="TimeSlot"
                                value={country_id}
                                onChange={(e) => {
                                  this.setState({
                                    country_id: e.target.value,
                                  });
                                }}
                              >
                                <option value=""></option>
                                {countryList.map((data) => (
                                  <option
                                    key={data.country_id}
                                    value={data.country_id}
                                  >
                                    {data.CountryName}
                                  </option>
                                ))}
                              </select>
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {countryErr}
                                </span>
                              }

                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label>
                                Address <span class="mendatory_class">*</span>
                              </label>
                              <textarea
                                value={address}
                                onChange={(e) =>
                                  this.InputFormat(e, "address")
                                }
                                class="form-control outside"
                                rows={2}
                                defaultValue={""} maxLength={1000}
                              />
                              {
                                <span className="text-danger text-start text-left d-block mt-1">
                                  {addressErr}
                                </span>
                              }

                            </div>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                    <fieldset>
                      <legend>Demographic Information</legend>
                      <div class="outside_input_field ">
                        <div class="row">
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>
                                Education Level{" "}
                              </label>
                              <input
                                value={EducationLevel}
                                type="text"
                                class="form-control border-input border-input"
                                required
                                onChange={(e) => {
                                  this.setState({
                                    EducationLevel: e.target.value,
                                    EducationLevelErr: "",
                                  });
                                }}
                                maxLength={50}
                              />
                            </div>
                          </div>
                          <div class="col-md-4">
                            <div class="form-group">
                              <label>
                                Background and Experience{" "}
                              </label>
                              <input
                                value={BackgroundExperience}
                                type="text"
                                class="form-control border-input border-input"
                                required
                                // onKeyDown={(e) => this.handleKeyDown(e)}
                                onChange={(e) =>
                                  this.setState({
                                    BackgroundExperience: e.target.value,
                                  })
                                }
                                maxLength={500}
                              />

                            </div>
                          </div>

                          <div class="col-md-4">
                            <div class="form-group">
                              <label>
                                Language Proficiency{" "}
                              </label>
                              <input
                                value={LanguageProficiency}
                                type="text"
                                class="form-control border-input border-input"
                                required
                                onChange={(e) =>
                                  this.setState({
                                    LanguageProficiency: e.target.value,
                                  })
                                }
                                maxLength={500}
                              />
                            </div>
                          </div>
                        </div>

                        <div class="row">
                          <div class="col-md-12">
                            <div class="form-group">
                              <label>
                                About Me
                              </label>
                              <textarea
                                value={about_me}
                                class="form-control outside"
                                rows={2} maxLength={500}
                                defaultValue={""}
                                onChange={(e) => this.setState({ about_me: e.target.value })}
                              />
                            </div>
                          </div>
                        </div>

                      </div>
                    </fieldset>

                    <fieldset>
                      <legend>Upload Profile Picture</legend>
                      <div className="outside_input_field">
                        <div className="row">
                          <div className="" style={{ padding: "0px 11px 10px" }}>
                            <div className="profile-upload ml-4">
                              <div className="profile-preview position-relative ml-4">
                                {console.log(this.state.FilePath, "image preview")}
                                <img
                                  src={this.state.FilePath ? (this.state.FilePath || `${downloadUrl + FilePath}`) : "img/avatar.jpg"}
                                  alt="Profile Preview"
                                  className="rounded-circle profile-pic"
                                  width="150"
                                  height="150"
                                  onClick={this.triggerFileInput}
                                  style={{ cursor: 'pointer' }}
                                />
                                <input
                                  type="file"
                                  ref={(ref) => (this.fileInputRef = ref)}
                                  className="form-control-file"
                                  onChange={this.handleImageUpload}
                                  accept="image/jpeg,image/png,image/jpg"
                                  style={{ display: 'none' }}
                                />

                                {/* Pencil icon overlay */}
                                <div
                                  className="edit-icon profile_edit_btn"
                                  onClick={this.triggerFileInput}
                                >
                                  <i className="fa fa-pencil text-primary" style={{ fontSize: '13px' }}></i>
                                </div>
                                <div
                                  className="edit-icon profile_close_btn"
                                  onClick={this.clearFileInput}
                                >
                                  <i className="fa fa-times" style={{ fontSize: '13px' }}></i>
                                </div>
                              </div>
                            </div>

                          </div>
                        </div>
                      </div><div class="col-md-3 mt-4">
                        <div class="form-group">
                          <label>
                            Jury Profile Details<span className="mendatory_class">*</span>
                          </label>
                          {ProfileFileName == '' ?
                            <div class="form-group mt-1" >
                              <input type="file" name="files"
                                class="custom-file-input form-control"
                                id="customFile"
                                onChange={(e) => this.onProfileFormFilePick(e, e.target.files)}
                              />
                              <label class="custom-file-label" for="customFile"
                              >Upload Profile Details</label>
                            </div> :
                            <div className='membership_file' >
                              {profile_filepath != null && profile_filepath != '' ?
                                <span className='overflow-membership'><a
                                  href={BASE_URL.split('/api')[0] + profile_filepath}
                                  target='blank' style={{ textDecoration: 'none', color: '#414244' }}>{ProfileFileName}</a></span> :
                                <span className='overflow-membership'
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => this.handleViewFile(ProfileFilePath, ProfileFileName)}
                                >{ProfileFileName}</span>
                              }
                              <span
                                className='membership_file_cross text-danger'
                                onClick={(e) => this.removeProfileFormFile()}
                              >X</span>
                            </div>
                          }
                        </div>
                      </div>
                    </fieldset>

                    <div className="row">
                      <div className="col-md-12">
                        <button class="btn btn-outline-primary mr-2 px-3" onClick={(e) => this.handleSubmit(e)}>{jury_id ? "Update" : "Save"}</button>
                        <button class="btn btn-outline-secondary px-3" onClick={() => this.navigateBackJuryList()}>Back</button>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main >
          <Footer />
          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    fill_action,
    jury_profile_insertUpdate_action,
    jury_profile_detail_action,
  })(JuryProfileAU)
);
